import { useLocation } from 'react-router-dom';

function useQuery() {
  const { search } = useLocation();
  return search ? new URLSearchParams(search) : new URLSearchParams();
}

export default useQuery;
